export default (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
        <rect width="10" height="10" rx="2" />
    </svg>
)
